module.exports = __webpack_public_path__ + "static/media/airport-destination.a3e6db08.svg";